import restApiRequest from '../apiRequestClients/restApiRequest';
//import applyPagerParams from '../utils/pagerParser';
//import applyFilterParams from '../utils/filterParser';
//import applySortingParams from '../utils/sortingParser';

const BASE_URL = '/sap';

export default apiUrl => {
    const apiRequest = restApiRequest(apiUrl);

    return {
        info(params = {}) {
            if (!params.id || typeof params.id !== 'number') {
                throw new Error({ error: `Expected rebate agreement number param to be Number, got ${typeof params.id}` });
            }

            const sendParams = { url: `${BASE_URL}/${params.id}`, data: {} };
            console.log('sendParams ', sendParams);

            return apiRequest.get(sendParams);
        },
        infoNonsig(params = {}) {
            if (!params.id || typeof params.id !== 'number') {
                throw new Error({ error: `Expected nonsig number param to be Number, got ${typeof params.id}` });
            }

            const sendParams = { url: `${BASE_URL}nonsig/${params.id}`, data: {} };
            console.log('sendParams ', sendParams);

            return apiRequest.get(sendParams);
        },
        validateJTAccInfo(params = {}) {
            if (!params.companyCode || typeof params.companyCode !== 'string') {
                throw new Error({ error: `Expected company code param to be String, got ${typeof params.companyCode}` });
            }

            if (!params.glCode || typeof params.glCode !== 'string') {
                throw new Error({ error: `Expected GL code param to be String, got ${typeof params.glCode}` });
            }

            const sendParams = { url: `${BASE_URL}/company-code/${params.companyCode}/gl-code/${params.glCode}/validate`, data: { costCenter: params.costCenter, profitCenter: params.profitCenter } };
            console.log('sendParams ', sendParams);

            return apiRequest.post(sendParams);
        },
    };
};
